    // document.querySelector(".select-popout__toggle").addEventListener("click", function () {
    //     let isExpanded = this.getAttribute("aria-expanded") === "true";
    //     this.setAttribute("aria-expanded", !isExpanded);
    //     var classname = "select-popout__list--visible select-popout__list--top"
    //    this.closest(".select-popout").querySelector(".select-popout__list").classList.toggle('select-popout__list--visible');
    //    this.closest(".select-popout").querySelector(".select-popout__list").classList.toggle('select-popout__list--top');
    // });


$(document).ready(function(){
  $('.split-images__scale').on("click",function(){
    var link = $(this).attr('data-href');
    window.location.href = link;
  });

  if(window.innerWidth <= 768){
     $('.split-images__content').on("click",function(){
    var link = $('.split-images__scale:eq(1)').attr('data-href');
    window.location.href = link;
  });

    $('.itg-images-main').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
      arrows : false,
      autoplay : true,
      dots : false
    });
  }


  
});

